import { combineReducers } from "@reduxjs/toolkit";
import { api } from "api/api";
import authReducer from "slides/auth/authSlice";
import notificationReducer from "slides/notification/notificationSlice";
import notificationBellReducer from "slides/notificationBell/notificationBellSlice";

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  auth: authReducer,
  notification: notificationReducer,
  notificationBell: notificationBellReducer,
});
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
